import {r as a, l as load} from '@theme/theme-sections';
import {s as p} from '@theme/section-slider-lifecycle';
import {loadCarouselDependencies} from '@theme/carousel-dependencies';
const d = 'complete-the-look';
var l, c, h;
const g =
    ((h = (c = (l = window.Shopify) == null ? void 0 : l.theme) == null ? void 0 : c.sections) == null
      ? void 0
      : h.registered) || {},
  S = typeof g[d] > 'u',
  s = {
    grid: '.complete-the-look__grid',
    products: '[data-products]',
    productItem: '.complete-the-look__product-list-item',
    progressBar: '[data-slider-progress-bar]',
  };
S &&
  a(d, {
    ...p,
    onLoad() {
      this.teardown(),
        (this.sectionActive = !0),
        (this.slider = null),
        (this.elements = {
          section: this.container.closest('.shopify-section') || this.container,
          grid: this.container.querySelector(s.grid),
          productsEl: this.container.querySelector(s.products),
          progressBar: this.container.querySelector(s.progressBar),
        });
      this.listenForSliderDemand();
      loadCarouselDependencies({progress: true}).catch(error => {
        if (this.isSectionActive()) console.warn('Could not preload carousel:', error);
      });
      this.loadComplementaryProducts();
    },
    initSlider() {
      if (!this.isSectionActive() || !this.elements.productsEl?.querySelector(s.productItem)) return;
      return this.withSliderDependencies(dependencies => this.createSlider(dependencies));
    },
    createSlider({Flickity: u, SliderProgressIndicator: m}) {
      const t = this.elements.productsEl;
      !this.isSectionActive() ||
        !t ||
        (this.destroySlider(),
        (this.slider = new u(t, {
          prevNextButtons: !0,
          pageDots: !1,
          cellAlign: 'left',
          contain: !0,
          groupCells: !0,
          watchCSS: !0,
          draggable: !0,
          arrowShape: 'M62.5 77.6517L34.8484 50L62.5 22.3484L65.1517 25L40.1517 50L65.1517 75L62.5 77.6517Z',
        })),
        this.trackVisibleSliderCells(),
        this.elements.progressBar &&
          (this.progressIndicator = new m({element: this.elements.progressBar, slider: this.slider})),
        this.scheduleSliderResize());
    },
    loadComplementaryProducts() {
      this.sliderRequest = null;
      var i;
      (i = this.requestController) == null || i.abort(),
        cancelAnimationFrame(this.initFrame),
        (this.initFrame = null),
        this.destroySlider(),
        (this.requestController = new AbortController());
      const t = this.requestController;
      fetch(this.container.dataset.url, {signal: t.signal})
        .then((e) => {
          if (!e.ok) throw new Error(`Could not load complementary products: ${e.status}`);
          return e.text();
        })
        .then((e) => {
          if (!this.isSectionActive() || t !== this.requestController) return;
          const r = document.createElement('div');
          r.innerHTML = e;
          const o = r.querySelector(`[data-section-id="${this.id}"]`),
            n = o == null ? void 0 : o.querySelector(s.products);
          if (!n?.querySelector(s.productItem)) {
            this.container.setAttribute('aria-busy', 'false');
            this.hideSection();
            return;
          }
          this.showSection(),
            (this.elements.productsEl.innerHTML = n.innerHTML),
            this.updateProductCountClass(),
            this.container.setAttribute('aria-busy', 'false'),
            this.initSlider();
        })
        .catch((e) => {
          if (e.name !== 'AbortError' && this.isSectionActive() && t === this.requestController) {
            console.warn(e);
            this.container.setAttribute('aria-busy', 'false');
            this.hideSection();
          }
        })
        .finally(() => {
          t === this.requestController && (this.requestController = null);
        });
    },
    updateProductCountClass() {
      var i, e;
      if (!((i = this.elements) != null && i.grid) || !((e = this.elements) != null && e.productsEl)) return;
      const t = Math.min(this.elements.productsEl.querySelectorAll(s.productItem).length, 3);
      Array.from(this.elements.grid.classList)
        .filter((r) => r.startsWith('complete-the-look__grid--'))
        .forEach((r) => this.elements.grid.classList.remove(r)),
        this.elements.grid.classList.add(`complete-the-look__grid--${t}`);
    },
  });
// Also load the first instance inserted after the theme editor has initialised.
load(d);
